$(function () {
  const $input = $('[data-behavior=select-checkboxes]')
  $input.on('click', function(e) {
    e.preventDefault()
    const cls = $input.data('select-class')
    $(`.${cls}`).attr("checked", "checked")
  })
});
